module.exports = __webpack_public_path__ + "img/plataformas-the-members.ca9c8fa7.svg";